const USER_TOKEN_COOKIE_KEY = 'ob_access_key';
const USER_REFRESH_TOKEN_COOKIE_KEY = 'ob_refresh_token_key';
const ANONYMOUS_TOKEN_CACHE_KEY = 'ANONYMOUS_ACCESS_KEY_TOKEN';
const ACTIVE_PROFILE_ID = 'ob_active_profile_id';
const TRACKING_SESSION_KEY = 'ob_tracking_session';
const USER_COUNTRY_CODE = 'ob_country_code';
const USER_SESSION = 'ob_session';
const USER_SESSION_INFO = 'ob_user';
const PROFILE_SWITCH = 'ob_profile_switch';
const SOCIAL_LOGIN = 'ob_social_login';
const LOGIN_TYPE = 'ob_login_type';
const OB_USER_ID = 'ob_user_id';
const OB_EMAIL_ID = 'ob_email_id';
const FIRST_EDIT = 'ob_first_edit';

module.exports = {
  USER_TOKEN_COOKIE_KEY,
  USER_REFRESH_TOKEN_COOKIE_KEY,
  ANONYMOUS_TOKEN_CACHE_KEY,
  ACTIVE_PROFILE_ID,
  TRACKING_SESSION_KEY,
  USER_COUNTRY_CODE,
  USER_SESSION,
  USER_SESSION_INFO,
  PROFILE_SWITCH,
  SOCIAL_LOGIN,
  LOGIN_TYPE,
  OB_USER_ID,
  OB_EMAIL_ID,
  FIRST_EDIT,
};
